import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

const initialState = {
  avvisiPagamento: [],
  filteredAvvisiPagamento: [],
  filters: {
    daData: '',
    aData: ''
  }
}

const insolutiSlice = createSlice({
  name: 'insoluti',
  initialState,
  reducers: {
    setAvvisiPagamento: (state, action) => {
      state.avvisiPagamento = action.payload
      state.filteredAvvisiPagamento = action.payload
    },
    filterAvvisiPagamento: (state, action) => {
      const { daData, aData } = action.payload
      state.filters = { daData, aData }
      state.filteredAvvisiPagamento = state.avvisiPagamento.filter((avviso:any) => {
        const avvisoDate = moment(avviso.dataEmissione, 'YYYY-MM-DD')
        const fromDate = moment(daData, 'YYYY-MM-DD')
        const toDate = moment(aData, 'YYYY-MM-DD')
        return avvisoDate.isBetween(fromDate, toDate, 'days', '[]')
      })
      return state
    }
  }
})

export const { setAvvisiPagamento, filterAvvisiPagamento } = insolutiSlice.actions

export default insolutiSlice.reducer
